export const THEME_REQUEST = "THEME_REQUEST";
export const THEME_SUCCESS = "THEME_SUCCESS";
export const THEME_FAILURE = "THEME_FAILURE";
export const SET_THEME = "SET_THEME";
export const UPDATE_THEME = "UPDATE_THEME";
export const UPDATE_THEME_TEMPLATE = "UPDATE_THEME_TEMPLATE";
export const SAVE_THEME_REQUEST = "SAVE_THEME_REQUEST";
export const SAVE_THEME_SUCCESS = "SAVE_THEME_SUCCESS";
export const SAVE_THEME_FAILURE = "SAVE_THEME_FAILURE";

export type ThemeData = {
  algorithm?: "default" | "dark";
  token?: Record<string, any>;
  components?: Record<string, any>;
};

export type ThemeState = {
  loading: boolean;
  data: ThemeData;
  error?: string | null;
};

// Default state shape (actual initial values are provided in reducer)
export const defaultThemeState: ThemeState = {
  loading: false,
  data: {
    algorithm: "default",
    token: {
      colorPrimary: "#1677ff",
      colorSuccess: "#52c41a",
      colorWarning: "#faad14",
      colorError: "#ff4d4f",
      colorInfo: "#1677ff",

      colorBgBase: "#ffffff",
      colorTextBase: "#141414",

      borderRadius: 8,
      fontFamily:
        "system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial",
      fontSize: 14,
      lineHeight: 1.5715,

      controlHeight: 32,
      controlHeightSM: 24,
      controlHeightLG: 40,

      wireframe: false,
      motion: true,
    },
  },
  error: null,
};

export type ThemeRequest = {
  type: typeof THEME_REQUEST;
  payload?: { propcode?: string };
};
export type ThemeSuccess = {
  type: typeof THEME_SUCCESS;
  payload: ThemeData;
};
export type ThemeFailure = {
  type: typeof THEME_FAILURE;
  payload: string;
};
export type SetTheme = {
  type: typeof SET_THEME;
  payload: ThemeData;
};

export type UpdateTheme = {
  type: typeof UPDATE_THEME;
  payload: ThemeData;
};

export type UpdateThemeTemplate = {
  type: typeof UPDATE_THEME_TEMPLATE;
  payload: ThemeData;
};

export type SaveThemeRequest = {
  type: typeof SAVE_THEME_REQUEST;
  payload: {
    propCode: string;
    themeData: ThemeData;
  };
};

export type SaveThemeSuccess = {
  type: typeof SAVE_THEME_SUCCESS;
};

export type SaveThemeFailure = {
  type: typeof SAVE_THEME_FAILURE;
  payload: string;
};

export type ThemeAction =
  | ThemeRequest
  | ThemeSuccess
  | ThemeFailure
  | SetTheme
  | UpdateTheme
  | UpdateThemeTemplate
  | SaveThemeRequest
  | SaveThemeSuccess
  | SaveThemeFailure;
